import moment from 'moment-timezone';

export const getEarnMaturityDateTranslationKey = (date: string | null) => {
  if (date === null) {
    return { key: 'earn-invest::glossary.flexible' };
  }

  const today = moment();
  const maturityDate = moment(date);
  const daysLeft = today.diff(maturityDate, 'days');
  const daysDiff = Math.abs(daysLeft);

  if (daysDiff === 0) {
    return {
      key: 'earn-invest::glossary.today'
    };
  }

  // Check if the maturity date is expired
  if (today.isAfter(maturityDate)) {
    if (daysDiff === 1) {
      return {
        key: 'earn-invest::glossary.maturity-expired_one',
        option: { day: daysDiff }
      };
    }
    return {
      key: 'earn-invest::glossary.maturity-expired_plural',
      option: { days: daysDiff }
    };
  }

  if (daysDiff === 1) {
    return {
      key: 'earn-invest::glossary.in-days_one',
      option: { day: daysDiff }
    };
  }

  return {
    key: `earn-invest::glossary.in-days_plural`,
    option: { days: Math.abs(daysLeft) }
  };
};

export const getEarnMaturityInDaysTranslationKey = (date: string | null) => {
  if (date === null) {
    return { key: 'earn-invest::glossary.flexible' };
  }

  const today = moment();
  const maturityDate = moment(date);
  const daysLeft = today.diff(maturityDate, 'days');
  const daysDiff = Math.abs(daysLeft);

  if (daysDiff === 0) {
    return {
      key: 'earn-invest::glossary.today'
    };
  }

  if (daysDiff === 1) {
    return {
      key: 'earn-invest::glossary.day',
      options: { day: daysDiff }
    };
  }

  return {
    key: `earn-invest::glossary.days`,
    options: { day: Math.abs(daysLeft) }
  };
};

export const getDaysAndHoursToMaturity = (date: string | null | undefined) => {
  if (date === null || date === undefined) {
    return {
      key: 'earn-invest::glossary.flexible'
    };
  }

  const today = moment();
  const maturityDate = moment(date);
  const daysLeft = today.diff(maturityDate, 'days');
  const hoursLeft = today.diff(maturityDate, 'hours') % 24;

  return {
    key: 'earn-invest::glossary.days-hours-to-maturity',
    options: {
      days: Math.abs(daysLeft),
      hours: Math.abs(hoursLeft)
    }
  };
};
